import { isObject } from '@portals/shared-frontend/utils';

export function removeStringFromArray(array: string[], itemToRemove: string) {
  return array.filter((item) => item !== itemToRemove);
}

export function filterDefined<T>(array: (T | undefined)[]): T[] {
  return array.filter((item): item is T => item !== undefined);
}

export function deepEqual<T>(obj1: T, obj2: T): boolean {
  if (obj1 === obj2) return true;

  if (!isObject(obj1) || !isObject(obj2)) return false;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key)) return false;

    const val1 = obj1[key as keyof typeof obj1];
    const val2 = obj2[key as keyof typeof obj2];

    if (!deepEqual(val1, val2)) return false;
  }

  return true;
}
export function arraysDeepEqualUnordered<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false;

  const matched: boolean[] = new Array(arr2.length).fill(false);

  for (const item1 of arr1) {
    let found = false;
    for (const [i, element] of arr2.entries()) {
      if (!matched[i] && deepEqual(item1, element)) {
        matched[i] = true;
        found = true;
        break;
      }
    }
    if (!found) return false;
  }

  return true;
}
